import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  //mode: "history",
  mode: "hash",
  base: "/dgjzclient/",
  routes: [
    {
      path: '*',
      component: () => import('../components/nopage.vue')
    },
    {
      path: '/',
      component: () => import('../components/index.vue')
    },{//about
      path: '/about/aboutCenter',
      component: () => import('../components/about/aboutCenter.vue')
    },{
      path: '/about/dyReportsList',
      component: () => import('../components/about/dyReportsList.vue')
    },{
      path: '/about/dyReportsDetail',
      component: () => import('../components/about/dyReportsDetail.vue')
    },{
      path: '/about/parkInv',
      component: () => import('../components/about/parkInv.vue')
    },{
      path: '/about/parkApply',
      component: () => import('../components/about/parkApply.vue')
    },{
      path: '/about/hatchEnpList',
      component: () => import('../components/about/hatchEnpList.vue')
    },{
      path: '/about/hatchEnpDetail',
      component: () => import('../components/about/hatchEnpDetail.vue')
    },{
      path: '/about/joinUs',
      component: () => import('../components/about/joinUs.vue')
    },{
      path: '/about/contactUs',
      component: () => import('../components/about/contactUs.vue')
    },{//case
      path: '/case/list',
      component: () => import('../components/case/list.vue')
    },{
      path: '/case/detail',
      component: () => import('../components/case/detail.vue')
    },{//demand
      path: '/demand/index',
      component: () => import('../components/demand/index.vue')
    },{
      path: '/demand/proList',
      component: () => import('../components/demand/proList.vue')
    },{
      path: '/demand/expList',
      component: () => import('../components/demand/expList.vue')
    },{
      path: '/demand/resList',
      component: () => import('../components/demand/resList.vue')
    },{
      path: '/demand/proDetail',
      component: () => import('../components/demand/proDetail.vue')
    },{
      path: '/demand/expDetail',
      component: () => import('../components/demand/expDetail.vue')
    },{
      path: '/demand/resDetail',
      component: () => import('../components/demand/resDetail.vue')
    }/* ,{
      path: '/demand/proSearch',
      component: () => import('../components/demand/proSearch.vue')
    },{
      path: '/demand/expSearch',
      component: () => import('../components/demand/expSearch.vue')
    },{
      path: '/demand/resSearch',
      component: () => import('../components/demand/resSearch.vue')
    } */,{//expert
      path: '/expert/list',
      component: () => import('../components/expert/list.vue')
    },{
      path: '/expert/detail',
      component: () => import('../components/expert/detail.vue')
    }/* ,{
      path: '/expert/search',
      component: () => import('../components/expert/search.vue')
    } */,{//orgn
      path: '/orgn/list',
      component: () => import('../components/finorgn/list.vue')
    },{
      path: '/orgn/detail',
      component: () => import('../components/finorgn/detail.vue')
    }/* ,{
      path: '/orgn/search',
      component: () => import('../components/finorgn/search.vue')
    } */,{//info
      path: '/info/list',
      component: () => import('../components/info/list.vue')
    },{
      path: '/info/sub',
      component: () => import('../components/info/sub.vue')
    },{
      path: '/info/detail',
      component: () => import('../components/info/detail.vue')
    },{//resource
      path: '/resource/list',
      component: () => import('../components/resource/list.vue')
    },{
      path: '/resource/detail',
      component: () => import('../components/resource/detail.vue')
    },{//front
      path: '/front/list',
      component: () => import('../components/front/list.vue')
    },{
      path: '/front/detail',
      component: () => import('../components/front/detail.vue')
    },{//venture
      path: '/venture/list',
      component: () => import('../components/venture/list.vue')
    },{
      path: '/venture/detail',
      component: () => import('../components/venture/detail.vue')
    },{//choice
      path: '/choice/list',
      component: () => import('../components/choice/list.vue')
    },{
      path: '/choice/detail',
      component: () => import('../components/choice/detail.vue')
    },/* {
      path: '/resource/search',
      component: () => import('../components/resource/search.vue')
    }, */{//show
      path: '/show/list',
      component: () => import('../components/roadShow/list.vue')
    },{
      path: '/show/detail',
      component: () => import('../components/roadShow/detail.vue')
    }/* ,{
      path: '/show/search',
      component: () => import('../components/roadShow/search.vue')
    } */,{//user
      path: '/user/userInfo',
      component: () => import('../components/user/userInfo.vue')
    },{
      path: '/user/projectAdd',
      component: () => import('../components/user/userProjectAdd.vue')
    },{
      path: '/user/projectEdit',
      component: () => import('../components/user/userProjectEdit.vue')
    },{
      path: '/user/projectDemAdd',
      component: () => import('../components/user/userDemProAdd.vue')
    },{
      path: '/user/projectDemEdit',
      component: () => import('../components/user/userDemProEdit.vue')
    },{
      path: '/user/projectResAdd',
      component: () => import('../components/user/userDemResAdd.vue')
    },{
      path: '/user/projectResEdit',
      component: () => import('../components/user/userDemResEdit.vue')
    },{
      path: '/user/expertDemAdd',
      component: () => import('../components/user/userDemExpAdd.vue')
    },{
      path: '/user/expertDemEdit',
      component: () => import('../components/user/userDemExpEdit.vue')
    },{
      path: '/user/userDemExp',
      component: () => import('../components/user/userDemExp.vue')
    },{
      path: '/user/userDemExpDetail',
      component: () => import('../components/user/userDemExpDetail.vue')
    },{
      path: '/user/userDemPro',
      component: () => import('../components/user/userDemPro.vue')
    },{
      path: '/user/userDemProDetail',
      component: () => import('../components/user/userDemProDetail.vue')
    },{
      path: '/user/userDemRes',
      component: () => import('../components/user/userDemRes.vue')
    },{
      path: '/user/userDemResDetail',
      component: () => import('../components/user/userDemResDetail.vue')
    },{
      path: '/user/userItaCollect',
      component: () => import('../components/user/userItaCollect.vue')
    },{
      path: '/user/userItaLeave',
      component: () => import('../components/user/userItaLeave.vue')
    },{
      path: '/user/userItaGet',
      component: () => import('../components/user/userItaGet.vue')
    },{
      path: '/user/userItaPraise',
      component: () => import('../components/user/userItaPraise.vue')
    },{
      path: '/user/userMsg',
      component: () => import('../components/user/userMsg.vue')
    },{
      path: '/user/userProject',
      component: () => import('../components/user/userProject.vue')
    },{
      path: '/user/userProjectDetail',
      component: () => import('../components/user/userProjectDetail.vue')
    },{
      path: '/user/userExpert',
      component: () => import('../components/user/userExpert.vue')
    },{
      path: '/user/userExpertDetail',
      component: () => import('../components/user/userExpertDetail.vue')
    },{
      path: '/user/userExpertEdit',
      component: () => import('../components/user/userExpertEdit.vue')
    },{
      path: '/user/userInterest',
      component: () => import('../components/user/userInterest.vue')
    },{
      path: '/user/userOrgn',
      component: () => import('../components/user/userOrgn.vue')
    },{
      path: '/user/orgnAdd',
      component: () => import('../components/user/userOrgnAdd.vue')
    },{
      path: '/user/orgnEdit',
      component: () => import('../components/user/userOrgnEdit.vue')
    },{
      path: '/user/userOrgnDetail',
      component: () => import('../components/user/userOrgnDetail.vue')
    },//register
    /* {
      path: '/register/toRegister',
      component: () => import('../components/register/toRegister.vue')
    }, {
      path: '/register/enpRegister',
      component: () => import('../components/register/enpRegister.vue')
    },*/{
      path: '/register/link',
      component: () => import('../components/register/link.vue')
    },{
      path: '/register/expRegister',
      component: () => import('../components/register/expRegister.vue')
    },{
      path: '/register/orgRegister',
      component: () => import('../components/register/orgRegister.vue')
    },{//english
      path: '/en/index',
      component: () => import('../components/en/index.vue')
    },{
      path: '/en/aboutCenter',
      component: () => import('../components/en/about/aboutCenter_en.vue')
    },{
      path: '/en/parkInv',
      component: () => import('../components/en/about/parkInv_en.vue')
    },{
      path: '/en/parkApply',
      component: () => import('../components/en/about/parkApply_en.vue')
    },{
      path: '/en/contactUs',
      component: () => import('../components/en/about/contactUs_en.vue')
    },{
      path: '/en/joinUs',
      component: () => import('../components/en/about/joinUs_en.vue')
    },{
      path: '/en/resource/list',
      component: () => import('../components/en/resource/list_en.vue')
    },{
      path: '/en/resource/detail',
      component: () => import('../components/en/resource/detail_en.vue')
    },{
      path: '/en/expert/list',
      component: () => import('../components/en/expert/list_en.vue')
    },{
      path: '/en/expert/detail',
      component: () => import('../components/en/expert/detail_en.vue')
    },{
      path: '/en/orgn/list',
      component: () => import('../components/en/finorgn/list_en.vue')
    },{
      path: '/en/orgn/detail',
      component: () => import('../components/en/finorgn/detail_en.vue')
    },{
      path: '/en/demand/index',
      component: () => import('../components/en/demand/index_en.vue')
    },{
      path: '/en/demand/proList',
      component: () => import('../components/en/demand/proList_en.vue')
    },{
      path: '/en/demand/expList',
      component: () => import('../components/en/demand/expList_en.vue')
    },{
      path: '/en/demand/resList',
      component: () => import('../components/en/demand/resList_en.vue')
    },{
      path: '/en/demand/proDetail',
      component: () => import('../components/en/demand/proDetail_en.vue')
    },{
      path: '/en/demand/expDetail',
      component: () => import('../components/en/demand/expDetail_en.vue')
    },{
      path: '/en/demand/resDetail',
      component: () => import('../components/en/demand/resDetail_en.vue')
    },{
      path: '/en/info/list',
      component: () => import('../components/en/info/list_en.vue')
    },{
      path: '/en/info/sub',
      component: () => import('../components/en/info/sub_en.vue')
    },{
      path: '/en/info/detail',
      component: () => import('../components/en/info/detail_en.vue')
    },{
      path: '/en/dyReportsList',
      component: () => import('../components/en/about/dyReportsList_en.vue')
    },{
      path: '/en/dyReportsDetail',
      component: () => import('../components/en/about/dyReportsDetail_en.vue')
    },{//front
      path: '/en/front/list',
      component: () => import('../components/en/front/list_en.vue')
    },{
      path: '/en/front/detail',
      component: () => import('../components/en/front/detail_en.vue')
    },{//venture
      path: '/en/venture/list',
      component: () => import('../components/en/venture/list_en.vue')
    },{
      path: '/en/venture/detail',
      component: () => import('../components/en/venture/detail_en.vue')
    },{//choice
      path: '/en/choice/list',
      component: () => import('../components/en/choice/list_en.vue')
    },{
      path: '/en/choice/detail',
      component: () => import('../components/en/choice/detail_en.vue')
    },{
      path: '/en/hatchEnpList',
      component: () => import('../components/en/about/hatchEnpList_en.vue')
    },{
      path: '/en/hatchEnpDetail',
      component: () => import('../components/en/about/hatchEnpDetail_en.vue')
    },{
      path: '/en/case/list',
      component: () => import('../components/en/case/list_en.vue')
    },{
      path: '/en/case/detail',
      component: () => import('../components/en/case/detail_en.vue')
    },{
      path: '/en/show/list',
      component: () => import('../components/en/roadShow/list_en.vue')
    },{
      path: '/en/show/detail',
      component: () => import('../components/en/roadShow/detail_en.vue')
    },{
       path: '/en/user/userInfo',
       component: () => import('../components/en/user/userInfo_en.vue')
     },{
       path: '/en/user/projectAdd',
       component: () => import('../components/en/user/userProjectAdd_en.vue')
     },{
       path: '/en/user/projectEdit',
       component: () => import('../components/en/user/userProjectEdit_en.vue')
     },{
       path: '/en/user/projectDemAdd',
       component: () => import('../components/en/user/userDemProAdd_en.vue')
     },{
       path: '/en/user/projectDemEdit',
       component: () => import('../components/en/user/userDemProEdit_en.vue')
     },{
       path: '/en/user/projectResAdd',
       component: () => import('../components/en/user/userDemResAdd_en.vue')
     },{
       path: '/en/user/projectResEdit',
       component: () => import('../components/en/user/userDemResEdit_en.vue')
     },{
       path: '/en/user/expertDemAdd',
       component: () => import('../components/en/user/userDemExpAdd_en.vue')
     },{
       path: '/en/user/expertDemEdit',
       component: () => import('../components/en/user/userDemExpEdit_en.vue')
     },{
       path: '/en/user/userDemExp',
       component: () => import('../components/en/user/userDemExp_en.vue')
     },{
       path: '/en/user/userDemExpDetail',
       component: () => import('../components/en/user/userDemExpDetail_en.vue')
     },{
       path: '/en/user/userDemPro',
       component: () => import('../components/en/user/userDemPro_en.vue')
     },{
       path: '/en/user/userDemProDetail',
       component: () => import('../components/en/user/userDemProDetail_en.vue')
     },{
       path: '/en/user/userDemRes',
       component: () => import('../components/en/user/userDemRes_en.vue')
     },{
       path: '/en/user/userDemResDetail',
       component: () => import('../components/en/user/userDemResDetail_en.vue')
     },{
       path: '/en/user/userItaCollect',
       component: () => import('../components/en/user/userItaCollect_en.vue')
     },{
       path: '/en/user/userItaLeave',
       component: () => import('../components/en/user/userItaLeave_en.vue')
     },{
       path: '/en/user/userItaGet',
       component: () => import('../components/en/user/userItaGet_en.vue')
     },{
       path: '/en/user/userItaPraise',
       component: () => import('../components/en/user/userItaPraise_en.vue')
     },{
       path: '/en/user/userMsg',
       component: () => import('../components/en/user/userMsg_en.vue')
     },{
       path: '/en/user/userProject',
       component: () => import('../components/en/user/userProject_en.vue')
     },{
       path: '/en/user/userProjectDetail',
       component: () => import('../components/en/user/userProjectDetail_en.vue')
     },{
       path: '/en/user/userExpert',
       component: () => import('../components/en/user/userExpert_en.vue')
     },{
       path: '/en/user/userExpertDetail',
       component: () => import('../components/en/user/userExpertDetail_en.vue')
     },{
       path: '/en/user/userExpertEdit',
       component: () => import('../components/en/user/userExpertEdit_en.vue')
     } ,{
       path: '/en/user/userInterest',
       component: () => import('../components/en/user/userInterest_en.vue')
     },{
       path: '/en/register/expRegister',
       component: () => import('../components/en/register/expRegister_en.vue')
     },{
      path: '/en/user/userOrgn',
      component: () => import('../components/en/user/userOrgn_en.vue')
    },{
      path: '/en/user/orgnAdd',
      component: () => import('../components/en/user/userOrgnAdd_en.vue')
    },{
      path: '/en/user/orgnEdit',
      component: () => import('../components/en/user/userOrgnEdit_en.vue')
    },{
      path: '/en/user/userOrgnDetail',
      component: () => import('../components/en/user/userOrgnDetail_en.vue')
    },{
      path: '/en/register/orgRegister',
      component: () => import('../components/en/register/orgRegister_en.vue')
    }
  ]
})
